<template lang="pug">
  div#patient-table(fluid='' tag='section')
    v-snackbar(v-model='snackbar.show' :timeout='30000' :color='snackbar.color' top='' right='' :multi-line='multiLine')
      | {{ snackbar.text }}
      template(v-slot:action='{ attrs }')
        v-btn(dark='' text='' icon='' @click='snackbar.show = false' v-bind='attrs')
          v-icon mdi-close
    //- v-snackbar(v-model='snackbar.show' :timeout='30000' top='' right='' :color='snackbar.color')
    //-   | {{ snackbar.text }}
    //-   v-btn(dark='' text='' @click.native='snackbar.show = false' icon='')
    //-     v-icon mdi-close
    v-dialog(v-if="dialogImport" v-model='dialogImport' max-width="600px")
      v-card
        v-toolbar(text='' color='primary' dark='')
          v-toolbar-title Importar Pacientes
            v-btn(icon="" dark="" @click="dialogImport = false" style="position: absolute; top: 0px; right: 10px;")
              v-icon.primary.rounded mdi-close
        v-card-text
          div(style="widht: 100% text-align: center;")
            a(class="download-excel" href="https://firebasestorage.googleapis.com/v0/b/dental-produccion.appspot.com/o/files%2Fformato-paciente.xlsx?alt=media&token=4a34460a-2fff-4ee7-94da-85893026ef48") Descargar Plantilla para Carga de Pacientes
            p
              strong NOTA:
                p(class="note-download") Es importante que utilice el mismo formato indicado en el enlace con los mismos nombres de las columnas y el mismo orden, para no tener errores al momento de cargar la data caso contrario se puede tener inconsistencias.
            input#inputExcel(type='file' style="padding-top: 10px;")
          v-row(style='align-items: center;')
            v-col(cols='12')
              p Para asistencia contáctanos:
            v-col(cols='6' style='text-align:end;')
              v-btn.ml-2(min-width='0' text='' style='' @click="openLink('https://www.facebook.com/dental.prime.391/')")
                v-icon(color="black") mdi-facebook
              v-btn.ml-2(min-width='0' text=''  style="" @click="openLink('https://www.instagram.com/dentalprimeapp/')")
                v-icon(color="black") mdi-instagram
              v-btn.ml-2(min-width='0' text='' style="" @click="openLink('https://wa.me/+593984530998')")
                v-icon(color="black") mdi-whatsapp
        v-card-actions
          v-spacer
          v-btn(color='blue darken-1' text='' @click='dialogImport = false' :loading='loadingSaveUser')
            | Cancelar
    v-dialog(fullscreen="" v-model='pendingAccDialog')
      v-card
        pendingAccounts(@exit-pending="closePendingDialog")
    v-dialog(v-if="dialogPatient" fullscreen="" v-model='dialogPatient')
      v-card
        patient(:seeData="true" :seeAppointment="true" :selectedPatient.sync="selectedPatient" :idPatient="idPatient" @finishCreate="finishCreate" @exitPatient="closePatientDialog")
    v-dialog(v-if="reminderDialog" fullscreen="" v-model='reminderDialog')
      v-card
        patientReminder(:allPatients='patientLst' @exitPatientReminder="reminderDialog = false")
    base-material-card.px-5.py-3(icon='mdi-clipboard-text' title='Lista de pacientes')
      v-container#patient-table(fluid='' tag='section' style='padding:0px;')
        v-row
          v-col(cols="12" md="3")
            v-btn.mr-0(color='primary' rounded='' @click='addNewPatient' style="width: 100%;" id="patients-view-1")
              strong
                | AGREGAR NUEVO
                br
                | PACIENTE
          v-col(cols="12" md="3")
            v-btn.mr-0(color='#78909C' rounded='' @click='downLoadExcelFile' style="width: 100%;" id="patients-view-1")
              strong
                | DESCARGAR LISTA
                br
                | DE PACIENTES
          v-col(cols="12" md="3")
            v-btn.mr-0(color='#DC5F17' rounded='' @click='showReminderDialog' style="width: 100%;")
              strong
                | ENVIAR
                br
                | CORREOS
          v-col(cols="12" md="3")
            v-btn.mr-0(color='#e22e2e' rounded='' @click='importPatients' style="width: 100%;" id="patients-view-1")
              strong
                | IMPORTAR
                br
                | PACIENTES
          v-col(cols="12" md="9")
            v-text-field.purple-input(v-model='searchTable' label='Buscar Paciente' @keyup="searchPatient" append-icon='mdi-magnify')
          v-col(v-if='showPendingAcc' cols="12" md="3")
            v-btn.mr-0(color='#9c27b0' rounded='' @click='showPendingAccounts' style="width: 100%;" id="patients-view-1")
              strong
                | CUENTAS
                br
                | PENDIENTES
          v-col(cols="12" md="12" style='padding-top:0px;')
            //- v-progress-linear(indeterminate='' color='primary' v-if="viewProgressBar")
            v-skeleton-loader(:loading="cargando" type="table" v-if="viewProgressBar")
            v-data-table.mx-2#tablaDatos(:headers="headers" v-show="!viewProgressBar" :items="patientLstFilter" item-key="id" :search="search" dense fixed-header :loading="cargando" loading-text="Cargando Datos" :sort-by="ordenarPor" calculate-widths @current-items="getFiltered" :footer-props="{\'items-per-page-text':'Pacientes por página'\}")
              v-alert.pa-0.ma-0(slot='no-results', :value='true', color='error', icon='mdi-alert-octagon-outline')
                | Sin resultados
              v-alert.pa-0.ma-0(slot='no-data', :value='true', color='info', icon='mdi-information-outline')
                | Sin datos
              template(v-slot:item.action="{ item }")
                v-tooltip(bottom='')
                  template(v-slot:activator='{ attrs, on }')
                    v-btn(v-on='on' icon='' color='secondary' @click="printDataPatient(item)" :loading="loadingPrintDataPatient")
                      v-icon mdi-printer
                  span Imprimir Datos
                v-tooltip(bottom='')
                  template(v-slot:activator='{ attrs, on }')
                    v-btn(v-on='on' icon='' color='primary' @click="agendarCita(item)")
                      v-icon mdi-calendar
                  span Agendar Cita
                v-tooltip(bottom='')
                  template(v-slot:activator='{ attrs, on }')
                    v-btn(v-on='on' icon='' color='blue'  @click="printHistorialClinico(item)" :loading="loadingPrintHistorial")
                      v-icon mdi-arrow-down-bold
                  span Descargar Historial
                v-tooltip(bottom='')
                  template(v-slot:activator='{ attrs, on }')
                    v-btn(v-on='on' icon='' color='green'  @click='selectPatient(item)')
                      v-icon mdi-pencil
                  span Ver Datos - Editar
                v-tooltip(bottom='')
                  template(v-slot:activator='{ attrs, on }')
                    v-btn(v-on='on' icon='' color='green'  @click='chatToPatient(item)')
                      v-icon mdi-whatsapp
                  span Comunicarse
</template>
<script>
  import jsonPatient from './PdfFiles/patientData.json'
  import historialClinico from './PdfFiles/historialClinico.json'
  import * as functions from '../../../functions.js'
  import axios from 'axios'
  import readXlsxFile from 'read-excel-file'
  // import firebase from 'firebase'
  import firebase from 'firebase/app'
  import 'firebase/auth'
  import {enviarEvento} from "@/functions";

  export default {
    components: {
      Patient: () => import('@/views/dashboard/component/patient/PatientProfile'),
      PendingAccounts: () => import('@/views/dashboard/component/patient/PendingAccounts'),
      PatientReminder: () => import('@/views/dashboard/component/patient/PatientReminder'),
    },
    data: () => ({
      showPendingAcc: false,
      loadingSaveUser: false,
      snackbar: {
        show: false,
        text: '',
        color: '',
        place: '',
      },
      dialogImport: false,
      ordenarPor: 'data.data.hcNumber',
      search: '',
      cargando: false,
      reminderDialog: false,
      loadingPrintDataPatient: false,
      loadingPrintHistorial: false,
      dialogPatient: false,
      pendingAccDialog: false,
      patientLstFilter: [],
      searchTable: '',
      selectedPatient: {},
      idPatient: '',
      headers: [
        { text: 'Número H.C.', value: 'data.data.hcNumber', align: 'left', filterable: true },
        { text: 'Identificación', value: 'data.data.id', align: 'left', filterable: true },
        { text: 'Nombre', value: 'data.data.names', align: 'left', filterable: true },
        { text: 'Apellido', value: 'data.data.lastNames', align: 'left', filterable: true },
        { text: 'Celular', value: 'data.data.phone2', align: 'left', filterable: true },
        { text: 'Teléfono', value: 'data.data.phone1', align: 'left', filterable: true },
        { text: 'Acciones', align: 'center', value: 'action', sortable: false }, // No se cambia
      ],
    }),
    computed: {
      patientsPlan () {
        return this.$store.state.suscriptionPlan.plan
      },
      patientLst () {
        return this.$store.state.patients.pacientes
      },
      viewProgressBar () {
        return this.$store.state.patients.viewProgressBar
      },
      appointmentLst () {
        return this.$store.state.appointment.appointments
      },
    },
    watch: {
      patientLst () {
        this.viewProgressBar = false
        this.cargando = false
        this.patientLstFilter = this.patientLst
      },
    },
    created () {
      this.checkIfShowPendingBtn()
      this.patientLstFilter = this.$store.state.patients.pacientes
      // si no existe paciente, dirigie directo a crear uno nuevo
      // if (this.patientLstFilter === null) {
      //   this.addNewPatient()
      // }
    },
    methods: {
      checkIfShowPendingBtn () {
        const currentDrId = firebase.auth().currentUser ? firebase.auth().currentUser.uid : ''
        this.$store.dispatch('patients/checkIfShowPending', currentDrId).then(showDoubts => {
          if (showDoubts === true) {
            this.showPendingAcc = true
          }
        })
      },
      chatToPatient (patient) {
        const cellphone = patient.data.data.phone2
        // https://api.whatsapp.com/send?phone=+{{ *YOURNUMBER* }}&text=%20{{ *YOUR MESSAGE* }}
        if (cellphone) {
          if (cellphone.length === 10) {
            var formPatientNumber = cellphone.replace(cellphone[0], '+593')
            var messToClient = 'Hola ' + patient.data.data.names + ', no olvides tu revisión bucal semestral para mantener tu higiene bucal y prevenir problemas dentales. Un abrazo.'
            this.openLink(this.getLinkWhastapp(formPatientNumber, messToClient))
          } else {
            this.snackbar = {
              show: true,
              color: 'red',
              text: 'El número de celular del paciente debe tener 10 dígitos, seleccione el ícono "editar" en el paciente correspondiente, edite el número de celular y vuelva a presionar en el ícono "Comunicarse"',
            }
          }
        } else {
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Este paciente no tiene un número de celular registrado, por favor seleccione el ícono "editar" en el paciente correspondiente, edite el número de celular y vuelva a presionar en el ícono "Comunicarse"',
          }
        }
      },
      getLinkWhastapp (number, message) {
        var url = 'https://api.whatsapp.com/send?phone=' +
          number +
          '&text=' +
          encodeURIComponent(message)
        return url
      },
      closePatientDialog () {
        this.dialogPatient = false
        this.patientLstFilter = this.patientLst
      },
      closePendingDialog () {
        this.pendingAccDialog = false
        this.patientLstFilter = this.patientLst
      },
      openLink (link) {
        window.open(`${link}`, '_blank')
      },
      importPatients () {
        this.dialogImport = true
        setTimeout(() => {
          const inputExcel = document.getElementById('inputExcel')
          inputExcel.addEventListener('change', () => {
            readXlsxFile(inputExcel.files[0]).then(async (rows) => {
              this.loadingSaveUser = true
              let val1 = 0
              if (this.patientLst) {
                if (this.patientLst.length > 0) {
                  val1 = this.patientLst.length
                }
              }
              const val2 = this.patientsPlan
              if (val1 < val2) {
                const patientLst = []
                let globalBan = true
                for (let i = 1; i < rows.length; i++) {
                  let ban = true
                  let uidVal = ''
                  let msg = 'El campo {CAMPO} de la fila {FILA} no pude ser vacío. Por favor ingrese el campo indicado para continuar.'
                  if (!rows[i][1] || rows[i][1].toString().trim() === '') {
                    msg = msg.replace('{CAMPO}', 'Nombres')
                    msg = msg.replace('{FILA}', (i + 1))
                    ban = false
                  }
                  if (!rows[i][2] || rows[i][2].toString().trim() === '') {
                    msg = msg.replace('{CAMPO}', 'Apellidos')
                    msg = msg.replace('{FILA}', (i + 1))
                    ban = false
                  }
                  if (!rows[i][3] || rows[i][3].toString().trim() === '') {
                    msg = msg.replace('{CAMPO}', 'Tipo-Id')
                    msg = msg.replace('{FILA}', (i + 1))
                    ban = false
                  }
                  if (!rows[i][4] || rows[i][4].toString().trim() === '') {
                    msg = msg.replace('{CAMPO}', 'Id')
                    msg = msg.replace('{FILA}', (i + 1))
                    ban = false
                  }
                  if (!rows[i][5] || rows[i][5].toString().trim() === '') {
                    msg = msg.replace('{CAMPO}', 'Email')
                    msg = msg.replace('{FILA}', (i + 1))
                    ban = false
                  }
                  if (val1 > 0) {
                    const patientValid = this.patientLst.filter(
                      item => {
                        const idFilter = rows[i][4] ? rows[i][4] : ''
                        return (item.data.data.id === idFilter)
                      })
                    if (patientValid.length > 0) {
                      uidVal = patientValid[0].id
                    }
                  }
                  if (ban) {
                    const patientSend = {
                      hcNumber: rows[i][0] ? rows[i][0] : '',
                      pais: rows[i][14] ? rows[i][14] : '',
                      canton: rows[i][13] ? rows[i][13] : '',
                      provincia: '',
                      parroquia: rows[i][22] ? rows[i][22] : '',
                      postalCode: '',
                      paisRes: rows[i][21] ? rows[i][21] : '',
                      cantonRes: rows[i][20] ? rows[i][20] : '',
                      provinciaRes: '',
                      parroquiaRes: '',
                      postalCodeRes: '',
                      names: rows[i][1] ? rows[i][1] : '',
                      lastNames: rows[i][2] ? rows[i][2] : '',
                      tipoId: rows[i][3] ? rows[i][3] : '',
                      id: rows[i][4] ? rows[i][4] : '',
                      email: rows[i][5] ? rows[i][5] : '',
                      sex: rows[i][6] ? rows[i][6] : '',
                      estadoCivil: rows[i][7] ? rows[i][7] : '',
                      phone1: rows[i][8] ? rows[i][8] : '',
                      phone2: rows[i][9] ? rows[i][9] : '',
                      phone3: rows[i][10] ? rows[i][10] : '',
                      active: true,
                      notas: '',
                      city: rows[i][13] ? rows[i][13] : '',
                      country: rows[i][14] ? rows[i][14] : '',
                      place: rows[i][15] ? rows[i][15] : '',
                      nationality: rows[i][12] ? rows[i][12] : '',
                      bornDate: rows[i][16] ? rows[i][16] : '',
                      years: rows[i][17] ? rows[i][17] : '',
                      months: rows[i][18] ? rows[i][18] : '',
                      days: rows[i][19] ? rows[i][19] : '',
                      cityHome: rows[i][20] ? rows[i][20] : '',
                      countryHome: rows[i][21] ? rows[i][21] : '',
                      parish: '',
                      street: rows[i][23] ? rows[i][23] : '',
                      numberStreet: rows[i][24] ? rows[i][24] : '',
                      street2: rows[i][25] ? rows[i][25] : '',
                      neighborhood: rows[i][26] ? rows[i][26] : '',
                      referenceHome: '',
                      ethnicity: '',
                      ethnicityNat: '',
                      town: '',
                      educationLevel: rows[i][27] ? rows[i][27] : '',
                      stateEducationLevel: rows[i][28] ? rows[i][28] : '',
                      companyWorkType: rows[i][29] ? rows[i][29] : '',
                      ocupation: rows[i][30] ? rows[i][30] : '',
                      sureIess: rows[i][31] ? rows[i][31] : '',
                      sureSecundary: rows[i][32] ? rows[i][32] : '',
                      contactName: rows[i][33] ? rows[i][33] : '',
                      contactKinship: rows[i][34] ? rows[i][34] : '',
                      contactPhone: rows[i][36] ? rows[i][36] : '',
                      contactAddress: rows[i][35] ? rows[i][35] : '',
                      imagePatientUrl: '',
                      idimg: '',
                      addEdit: false,
                      completeData: rows[i][1] + ' ' + rows[i][2] + ' | ' + rows[i][4],
                    }
                    if (uidVal !== '') {
                      patientSend.uid = uidVal
                      patientLst.push(patientSend)
                    } else {
                      patientLst.push(patientSend)
                    }
                  } else {
                    globalBan = false
                    this.dialogImport = false
                    this.loadingSaveUser = false
                    this.snackbar = {
                      show: true,
                      color: 'red',
                      text: msg,
                    }
                    return
                  }
                }
                if (globalBan) {
                  let banEnd = true
                  let correctRegister = 0
                  let errorRegister = 0
                  if (patientLst.length > 0) {
                    for (let i = 0; i < patientLst.length; i++) {
                      await this.$store.dispatch('patients/addPatient', patientLst[i]).then(resolve => {
                        correctRegister++
                      }, reject => {
                        banEnd = false
                        errorRegister++
                      })
                    }
                    if (banEnd) {
                      this.dialogImport = false
                      this.loadingSaveUser = false
                      this.snackbar = {
                        show: true,
                        color: 'green',
                        text: 'Proceso finalizado con: ' + correctRegister + ' registros correctos y ' + errorRegister + ' registros incorrectos.',
                      }
                    } else {
                      this.dialogImport = false
                      this.loadingSaveUser = false
                      this.snackbar = {
                        show: true,
                        color: 'red',
                        text: 'Proceso finalizado con: ' + correctRegister + ' registros correctos y ' + errorRegister + ' registros incorrectos.',
                      }
                    }
                  } else {
                    this.dialogImport = false
                    this.loadingSaveUser = false
                    this.snackbar = {
                      show: true,
                      color: 'red',
                      text: 'No se tiene registros para agregar. Verifique si los pacientes no se encuentran ya agregados dentro del sistema verificando la identificación de los mismos.',
                    }
                  }
                }
              } else {
                this.dialogImport = false
                this.loadingSaveUser = false
                this.snackbar = {
                  show: true,
                  color: 'red',
                  text: 'Ha superado el límite de pacientes a ingresar dentro de su plan.',
                }
              }
            }).catch((e) => {
              this.dialogImport = false
              this.loadingSaveUser = false
              this.snackbar = {
                show: true,
                color: 'red',
                text: 'Error al momento de cargar el archivo. Verifique el archivo.',
              }
            })
          })
        }, 500)
      },
      showPendingAccounts () {
        this.pendingAccDialog = true
      },
      showReminderDialog () {
        this.reminderDialog = true
      },
      downLoadExcelFile () {
        const data = []
        if (this.patientLstFilter) {
          for (let i = 0; i < this.patientLstFilter.length; i++) {
            data.push({
              'Código HC': this.patientLstFilter[i].data.data.hcNumber ? this.patientLstFilter[i].data.data.hcNumber : '',
              Nombres: this.patientLstFilter[i].data.data.names,
              Apellidos: this.patientLstFilter[i].data.data.lastNames,
              'Tipo-Id': this.patientLstFilter[i].data.data.tipoId,
              Id: this.patientLstFilter[i].data.data.id,
              Email: this.patientLstFilter[i].data.data.email,
              Sexo: this.patientLstFilter[i].data.data.sex,
              'Estado-Civil': this.patientLstFilter[i].data.data.estadoCivil,
              'Tlf-1': this.patientLstFilter[i].data.data.phone1,
              Celular: this.patientLstFilter[i].data.data.phone2,
              'Tlf-2': this.patientLstFilter[i].data.data.phone3,
              Activo: this.patientLstFilter[i].data.data.active ? 'SI' : 'NO',
              Nacionalidad: this.patientLstFilter[i].data.data.nationality,
              Ciudad: this.patientLstFilter[i].data.data.city,
              País: this.patientLstFilter[i].data.data.country,
              Lugar: this.patientLstFilter[i].data.data.place,
              'Fecha de Nacimiento': this.patientLstFilter[i].data.data.bornDate,
              Años: this.patientLstFilter[i].data.data.years,
              Meses: this.patientLstFilter[i].data.data.months,
              Días: this.patientLstFilter[i].data.data.days,
              'Ciudad de Residencia': this.patientLstFilter[i].data.data.cityHome,
              'País de Residencia': this.patientLstFilter[i].data.data.countryHome,
              Parroquia: this.patientLstFilter[i].data.data.parish,
              'Calle Principal': this.patientLstFilter[i].data.data.street,
              'Número de Calle': this.patientLstFilter[i].data.data.numberStreet,
              'Calle Seundaria': this.patientLstFilter[i].data.data.street2,
              Barrio: this.patientLstFilter[i].data.data.neighborhood,
              'Nivel Educativo': this.patientLstFilter[i].data.data.educationLevel,
              'Estado Nivel Educativo': this.patientLstFilter[i].data.data.stateEducationLevel,
              'Tipo de Empresa': this.patientLstFilter[i].data.data.companyWorkType,
              Ocupación: this.patientLstFilter[i].data.data.ocupation,
              'Seguro IESS': this.patientLstFilter[i].data.data.sureIess ? 'SI' : 'NO',
              'Seguro Secundario': this.patientLstFilter[i].data.data.sureSecundary,
              'Nombre de Contacto': this.patientLstFilter[i].data.data.contactName,
              Parentezco: this.patientLstFilter[i].data.data.contactKinship,
              'Dirección de Cntacto': this.patientLstFilter[i].data.data.contactAddress,
              'Teléfono de Contacto': this.patientLstFilter[i].data.data.contactPhone,
              'Referido por': this.patientLstFilter[i].data.data.referedBy,
              'Nombre del padre': this.patientLstFilter[i].data.data.fatherName ? this.patientLstFilter[i].data.data.fatherName : '',
              'Nombre de la madre': this.patientLstFilter[i].data.data.motherName ? this.patientLstFilter[i].data.data.motherName : '',
              'Factura a nombre': this.patientLstFilter[i].data.data.billName ? this.patientLstFilter[i].data.data.billName : '',
            })
          }
          functions.JSONToCSVConvertor(data, 'Pacientes', true)
        }
      },
      agendarCita (patient) {
        this.$router.push({ name: 'Agenda', params: { id: patient.id } })
      },
      selectPatient (patient) {
        this.selectedPatient = patient.data.data
        this.selectedPatient.addEdit = true
        this.idPatient = patient.id
        this.dialogPatient = true
      },
      addNewPatient () {
        this.selectedPatient = null
        this.idPatient = ''
        this.dialogPatient = true
      },
      searchPatient () {
        this.patientLstFilter = this.patientLst.filter(
          patient => {
            return ((patient.data.data.id.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().includes(this.searchTable.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase())) ||
              (patient.data.data.names.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().includes(this.searchTable.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase())) ||
              (patient.data.data.lastNames.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().includes(this.searchTable.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase())) ||
              (patient.data.data.phone1.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().includes(this.searchTable.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase())) ||
              (patient.data.data.phone2.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().includes(this.searchTable.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase())))
          })
      },
      finishCreate () {
        this.dialogPatient = false
      },
      async printDataPatient (patient) {
        this.loadingPrintDataPatient = true
        const imgStr = patient.data.data.imagePatientUrl.toString().trim()
        if (imgStr === '' || patient.data.data.imagePatientUrl === null) {
          patient.data.data.imagePatientUrl = 'https://firebasestorage.googleapis.com/v0/b/dental-produccion.appspot.com/o/images%2Fuser.jpg?alt=media&token=b0ccde55-1ee5-4969-a983-24375e04e3f7'
        }
        // patient.data.data.imagePatientUrl = 'data:image/jpeg;base64,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'
        var pdfMake = require('pdfmake/build/pdfmake.js')
        if (pdfMake.vfs === undefined) {
          var pdfFonts = require('pdfmake/build/vfs_fonts.js')
          pdfMake.vfs = pdfFonts.pdfMake.vfs
        }
        // const { createCanvas, loadImage } = require('canvas')
        // function getImage (url, size) {
        //   return loadImage(url, { useCORS: true }).then(image => {
        //     const canvas = createCanvas(size, size)
        //     const ctx = canvas.getContext('2d')
        //     ctx.drawImage(image, 0, 0)
        //     return canvas.toDataURL()
        //   })
        // }
        // const imageData = await getImage(patient.data.data.imagePatientUrl, 150)
        var base64Img = ''
        try {
          base64Img = await axios
            .get(patient.data.data.imagePatientUrl, {
              responseType: 'arraybuffer',
            })
            .then(response =>
              Buffer.from(response.data, 'binary').toString('base64'),
            )
        } catch {
          base64Img = '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'
        }
        var docDefinition = JSON.stringify(jsonPatient)
        const imgData = 'data:image/jpeg;base64,' + base64Img
        docDefinition = docDefinition.replace('img_patient', imgData)
        docDefinition = docDefinition.replace('name_patient', patient.data.data.names)
        docDefinition = docDefinition.replace('last_name_patient', patient.data.data.lastNames)
        docDefinition = docDefinition.replace('tipoId', patient.data.data.tipoId)
        docDefinition = docDefinition.replace('id_patient', patient.data.data.id)
        docDefinition = docDefinition.replace('mail_patient', patient.data.data.email)
        docDefinition = docDefinition.replace('sexo_paciente', patient.data.data.sex)
        docDefinition = docDefinition.replace('estado_civil_paciente', patient.data.data.estadoCivil)
        docDefinition = docDefinition.replace('celular_paciente', patient.data.data.phone2)
        docDefinition = docDefinition.replace('tlf_principal', patient.data.data.phone1)
        docDefinition = docDefinition.replace('tlf_secundario', patient.data.data.phone3)
        docDefinition = docDefinition.replace('paciente_activo', patient.data.data.active ? 'SI' : 'NO')
        docDefinition = docDefinition.replace('nacionalidad_nac_paciente', patient.data.data.nationality)
        docDefinition = docDefinition.replace('ciudad_nac_paciente', patient.data.data.city)
        docDefinition = docDefinition.replace('pais_nac_paciente', patient.data.data.country)
        docDefinition = docDefinition.replace('lugar_nac_paciente', patient.data.data.place)
        docDefinition = docDefinition.replace('fec_nac_paciente', patient.data.data.bornDate)
        docDefinition = docDefinition.replace('years_nac_paciente', patient.data.data.years)
        docDefinition = docDefinition.replace('months_nac_paciente', patient.data.data.months)
        docDefinition = docDefinition.replace('days_nac_paciente', patient.data.data.days)
        docDefinition = docDefinition.replace('ciudad_res_paciente', patient.data.data.cityHome)
        docDefinition = docDefinition.replace('pais_res_paciente', patient.data.data.countryHome)
        docDefinition = docDefinition.replace('parroquia_res_paciente', patient.data.data.parish)
        docDefinition = docDefinition.replace('main_street_patient', patient.data.data.street)
        docDefinition = docDefinition.replace('number_street_patient', patient.data.data.numberStreet)
        docDefinition = docDefinition.replace('secondary_street_patient', patient.data.data.street2)
        docDefinition = docDefinition.replace('barrio_res_patient', patient.data.data.neighborhood)
        docDefinition = docDefinition.replace('autoidentificacion_adi_paciente', patient.data.data.ethnicity)
        docDefinition = docDefinition.replace('nac_et_adi_paciente', patient.data.data.ethnicityNat)
        docDefinition = docDefinition.replace('pueblo_adi_paciente', patient.data.data.town)
        docDefinition = docDefinition.replace('level_edu_adi_paciente', patient.data.data.educationLevel)
        docDefinition = docDefinition.replace('state_level_adi_paciente', patient.data.data.stateEducationLevel)
        docDefinition = docDefinition.replace('company_adi_paciente', patient.data.data.companyWorkType)
        docDefinition = docDefinition.replace('ocupacion_adi_paciente', patient.data.data.ocupation)
        docDefinition = docDefinition.replace('seguro_iess_adi_paciente', patient.data.data.sureIess)
        docDefinition = docDefinition.replace('seguro_privado_adi_paciente', patient.data.data.sureSecundary)
        docDefinition = docDefinition.replace('name_con_paciente', patient.data.data.contactName)
        docDefinition = docDefinition.replace('parentezco_con_paciente', patient.data.data.contactKinship)
        docDefinition = docDefinition.replace('dir_con_paciente', patient.data.data.contactAddress)
        docDefinition = docDefinition.replace('tlf_con_paciente', patient.data.data.contactPhone)
        docDefinition = docDefinition.replace('nombre_padre', patient.data.data.fatherName ? patient.data.data.fatherName : '')
        docDefinition = docDefinition.replace('nombre_madre', patient.data.data.motherName ? patient.data.data.motherName : '')
        docDefinition = docDefinition.replace('factura_a_nombre', patient.data.data.billName ? patient.data.data.billName : '')
        docDefinition = JSON.parse(docDefinition)
        this.loadingPrintDataPatient = false
        pdfMake.createPdf(docDefinition).download('Datos_Pacientes.pdf')
      },
      async printHistorialClinico (patient) {
        this.loadingPrintHistorial = true
        const imgStr = patient.data.data.imagePatientUrl.trim()
        if (imgStr === '' || patient.data.data.imagePatientUrl === null) {
          patient.data.data.imagePatientUrl = 'https://firebasestorage.googleapis.com/v0/b/dental-produccion.appspot.com/o/images%2Fuser.jpg?alt=media&token=b0ccde55-1ee5-4969-a983-24375e04e3f7'
        }
        // patient.data.data.imagePatientUrl = 'data:image/jpeg;base64,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'
        var pdfMake = require('pdfmake/build/pdfmake.js')
        if (pdfMake.vfs === undefined) {
          var pdfFonts = require('pdfmake/build/vfs_fonts.js')
          pdfMake.vfs = pdfFonts.pdfMake.vfs
        }
        // const { createCanvas, loadImage } = require('canvas')
        // function getImage (url, size) {
        //   return loadImage(url, { useCORS: true }).then(image => {
        //     const canvas = createCanvas(size, size)
        //     const ctx = canvas.getContext('2d')
        //     ctx.drawImage(image, 0, 0)
        //     return canvas.toDataURL()
        //   })
        // }
        // const imageData = await getImage(patient.data.data.imagePatientUrl, 150)
        var base64Img = ''
        try {
          base64Img = await axios
            .get(patient.data.data.imagePatientUrl, {
              responseType: 'arraybuffer',
            })
            .then(response =>
              Buffer.from(response.data, 'binary').toString('base64'),
            )
        } catch {
          base64Img = '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'
        }
        let bodyTableAntecedentes = []
        let arrAntecedentes = []
        await this.$store.dispatch('antecedentes/loadAntecedentesLst', patient.id).then(res => {
          arrAntecedentes = res
        })
        if (arrAntecedentes.length > 0) {
          bodyTableAntecedentes = [
            ['Fecha', 'Antecedentes Personales', 'Antecedentes Familiares'],
          ]
          for (let i = 0; i < arrAntecedentes.length; i++) {
            let antPer = ''
            let antFam = ''
            if (arrAntecedentes[i].data.modelPersonalLst) {
              for (let j = 0; j < arrAntecedentes[i].data.modelPersonalLst.length; j++) {
                antPer = antPer + arrAntecedentes[i].data.modelPersonalLst[j].data + ', '
              }
            }
            if (arrAntecedentes[i].data.modelfamiliarLst) {
              for (let j = 0; j < arrAntecedentes[i].data.modelfamiliarLst.length; j++) {
                antFam = antFam + arrAntecedentes[i].data.modelfamiliarLst[j].data + ', '
              }
            }
            bodyTableAntecedentes.push(
              [
                arrAntecedentes[i].data.currentDate,
                { text: antPer, italics: true, color: 'gray' },
                { text: antFam, italics: true, color: 'gray' },
                // { text: '$ ' + arrAntecedentes[i].processCost, italics: true, color: 'gray' }
              ],
            )
          }
        } else {
          bodyTableAntecedentes = [
            ['Fecha', 'Antecedentes Personales', 'Antecedentes Familiares'],
          ]
        }
        let arrSignosVitales = []
        const arrTextSignos = []
        await this.$store.dispatch('signosvitales/loadSignosVitalesLst', patient.id).then(res => {
          arrSignosVitales = res
        })
        for (let i = 0; i < arrSignosVitales.length; i++) {
          arrTextSignos.push(
            {
              text: `Fecha: ${arrSignosVitales[i].data.currentDate}\n\n`, style: 'subheader',
            },
            {
              text: `Frecuencia Cardiaca: ${arrSignosVitales[i].data.frecuenciaCardiaca}     `,
            },
            {
              text: `Frecuencia Respiratoria: ${arrSignosVitales[i].data.frecuenciaRespiratoria}     `,
            },
            {
              text: `Glucosa Capilar: ${arrSignosVitales[i].data.glucosaCapilar}\n\n`,
            },
            {
              text: `Perímtro Abdominal: ${arrSignosVitales[i].data.perimetroAbdominal}     `,
            },
            {
              text: `Valor Hemoglobina: ${arrSignosVitales[i].data.valorHemoglobina}     `,
            },
            {
              text: `Peso: ${arrSignosVitales[i].data.peso}\n\n`,
            },
            {
              text: `Presión Arterial Media: ${arrSignosVitales[i].data.presionArterialMedia}     `,
            },
            {
              text: `Presión Arterial Sistólica: ${arrSignosVitales[i].data.presionArterialSistolica}     `,
            },
            {
              text: `Saturación Oxígeno: ${arrSignosVitales[i].data.saturacionOxigeno}\n\n`,
            },
            {
              text: `Talla Estatura: ${arrSignosVitales[i].data.tallaEstatura}     `,
            },
            {
              text: `Presión Arterial Diastólica: ${arrSignosVitales[i].data.presionArterialDiastolica}     `,
            },
            {
              text: `Imc: ${arrSignosVitales[i].data.imc}\n\n`,
            },
            {
              text: `Temperatura: ${arrSignosVitales[i].data.temperatura}     `,
            },
            {
              text: `Valor Hemoglobina: ${arrSignosVitales[i].data.valorHemoglobinaCorregido}\n\n`,
            },
          )
        }
        let arrQuestions = []
        await this.$store.dispatch('questions/loadQuestion', patient.id).then(res => {
          arrQuestions = res
        })
        const bodyTableQuestions = [
          ['Pregunta', 'Respuesta'],
        ]
        for (let i = 0; i < arrQuestions.length; i++) {
          bodyTableQuestions.push(
            [
              arrQuestions[i].pregunta,
              { text: arrQuestions[i].respuesta, italics: true, color: 'gray' },
            ],
          )
        }
        let appointmentLst = []
        await this.$store.dispatch('appointment/loadAppointmetsPrint', patient.id).then(res => {
          appointmentLst = res
        })
        const arrCitasPaciente = []
        for (let i = 0; i < appointmentLst.length; i++) {
          const processLabelStr = []
          let piezasStr = ''
          for (let j = 0; j < appointmentLst[i].data.arrProcesses.length; j++) {
            await this.$store.dispatch('odontogram/getProcessData', [patient.id, appointmentLst[i].data.arrProcesses[j]]).then(res => {
              if (res) {
                if (res.length > 0) {
                  const obj = JSON.parse(res[0].data)
                  for (let k = 0; k < obj.teethIdArray.length; k++) {
                    piezasStr = piezasStr + obj.teethIdArray[k].pieza + ', '
                  }
                  processLabelStr.push({ label: obj.processLabel, piezas: piezasStr })
                }
              }
            })
          }
          appointmentLst[i].data.lstProcesses = processLabelStr
          arrCitasPaciente.push(appointmentLst[i].data)
        }
        historialClinico.content.splice(20, historialClinico.content.length)
        for (let i = 0; i < arrCitasPaciente.length; i++) {
          const bodyTablePrescription = [
            ['Prescripción', 'Indicaciones', 'Observaciones'],
          ]
          bodyTablePrescription.push([
            arrCitasPaciente[i].prescription,
            { text: arrCitasPaciente[i].indications, italics: true, color: 'gray' },
            { text: arrCitasPaciente[i].observations, italics: true, color: 'gray' },
          ])
          const bodyTableTratamientos = [
            ['Procedimiento', 'Piezas'],
          ]
          for (let k = 0; k < arrCitasPaciente[i].lstProcesses.length; k++) {
            bodyTableTratamientos.push([
              arrCitasPaciente[i].lstProcesses[k].label,
              { text: arrCitasPaciente[i].lstProcesses[k].piezas, italics: true, color: 'gray' },
            ])
          }
          historialClinico.content.push(
            {
              text: `Fecha: ${arrCitasPaciente[i].currentDate}\n`, style: 'subheader',
            }, '\n',
            {
              style: 'tableExample',
              table: {
                widths: [100, 200, 200],
                body: bodyTablePrescription,
              },
            }, '\n\n',
            {
              style: 'tableExample',
              table: {
                widths: [300, 210],
                body: bodyTableTratamientos,
              },
            }, '\n\n',
          )
        }
        historialClinico.content[8].table.body = bodyTableAntecedentes
        historialClinico.content[12].table.body = bodyTableQuestions
        historialClinico.content[16].text = arrTextSignos
        var docDefinition = JSON.stringify(historialClinico)
        const imgData = 'data:image/jpeg;base64,' + base64Img
        docDefinition = docDefinition.replace('img_patient', imgData)
        docDefinition = docDefinition.replace('name_patient', patient.data.data.names)
        docDefinition = docDefinition.replace('last_name_patient', patient.data.data.lastNames)
        docDefinition = docDefinition.replace('tipoId', patient.data.data.tipoId)
        docDefinition = docDefinition.replace('id_patient', patient.data.data.id)
        docDefinition = docDefinition.replace('mail_patient', patient.data.data.email)
        docDefinition = docDefinition.replace('sexo_paciente', patient.data.data.sex)
        docDefinition = docDefinition.replace('estado_civil_paciente', patient.data.data.estadoCivil)
        docDefinition = docDefinition.replace('celular_paciente', patient.data.data.phone2)
        docDefinition = docDefinition.replace('tlf_principal', patient.data.data.phone1)
        docDefinition = docDefinition.replace('tlf_secundario', patient.data.data.phone3)
        docDefinition = docDefinition.replace('paciente_activo', patient.data.data.active ? 'SI' : 'NO')
        docDefinition = JSON.parse(docDefinition)
        this.loadingPrintHistorial = false
        pdfMake.createPdf(docDefinition).download('HC_' + patient.data.data.names.replace(' ', '_') + '_' + patient.data.data.lastNames.replace(' ', '_') + '.pdf')
      },
    },
    mounted() {
      enviarEvento('patient_table', { categoria: 'interaccion', etiqueta: 'inicio' })
    }
  }
</script>
<style lang="scss">
  .import-patient {
    width: 150px;
    position: absolute;
    right: 50px;
    top: 40px;
  }
  .download-excel {
    color: #0591a3 !important;
  }
  .download-excel:hover {
    color: #1f6c75 !important;
    text-decoration: underline;
  }
  .note-download {
    font-size: 12px;
    text-align: justify;
    color: red;
  }
  .theme--light.v-data-table tbody tr:not(:last-child) td:last-child, .theme--light.v-data-table tbody tr:not(:last-child) th:last-child {
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    padding: 0;
  }
</style>
